import { render, staticRenderFns } from "./PopularUsers.vue?vue&type=template&id=5ea709dc&"
import script from "./PopularUsers.vue?vue&type=script&lang=js&"
export * from "./PopularUsers.vue?vue&type=script&lang=js&"
import style0 from "./PopularUsers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports